// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3654":"css/app.6901","9957":"css/admin-app.6901"}[chunkId] + ".css";
};